import moment from 'moment';
import * as devisConf from '@/configuration/devisConf';

export default function updateQuantiteLiaisonTarif(liaisonsTarifs, dateDebut, dateFin) {
  if (liaisonsTarifs
    && liaisonsTarifs.quantite === 1
    && liaisonsTarifs.uniteVente === devisConf.JOUR) {
    liaisonsTarifs.quantiteAjustee = (moment(dateFin).diff(dateDebut, 'days') + 1);
  }
}
